import React from 'react';
import styles from './PageTitle.module.css';
import cx from 'clsx';

const PageTitle: React.FC<{ title: string, className?: string }> = ({ title, className = '' }) => (
  <div className={cx(styles.title, className)}>{title}</div>
);

export default PageTitle;
